import { createSlice } from '@reduxjs/toolkit';
import { first, get } from 'lodash';
import { accountsApi } from 'src/api/account-api';

const initialState = {
  pageState: {
    tab: ''
  }
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    resetState: () => initialState,
    resetPageState: (state) => {
      state.pageState = initialState.pageState;
    },
    changeTab: (state, action) => {
      state.pageState.tab = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(accountsApi.endpoints.getMe.matchFulfilled, (state, action) => {
      const manageRoles = get(action.payload, 'permissions.manage_roles');
      state.pageState.tab = first(manageRoles);
    });
  }
});

// Action creators are generated for each case reducer function
export const { resetState, resetPageState, changeTab } = userSlice.actions;

// Selectors
export const selectUserPageState = ({ user }) => user.pageState;

export const selectUserPageStateTab = ({ user }) => user.pageState.tab;

// Reducer
export default userSlice.reducer;
